var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPdf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3 2.16h7.92l5.94 5.94v11.88a1.98 1.98 0 0 1-1.98 1.98H6.3a1.98 1.98 0 0 1-1.98-1.98V4.14c0-1.099.881-1.98 1.98-1.98zm6.93 6.93h5.445L13.23 3.645V9.09zM9.27 19.98H7.29v-5.94h1.98v5.94zm1.98 0h1.98v-7.92h-1.98v7.92zm5.94 0h-1.98v-3.96h1.98v3.96z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon_pdf.c9462674bdfdc3425138b821a5523c82.svg";
export { ForwardRef as ReactComponent };